import FormatCurrency from 'components/Common/FormatCurrency'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import UrgencyLabel from 'components/Luxkit/Label/UrgencyLabel'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import { sortBy } from 'lib/array/arrayUtils'
import React, { useMemo } from 'react'
import OfferCalendarFlightDealBannerCountdown from './OfferCalendarFlightDealBannerCountdown'
import { fareCabinLabelMap, fareTypeLabelMap, FlightsClassTypes } from 'constants/flight'

interface Props {
  originAirportCode: string;
  destinationAirportCode: string;
}

export default function OfferCalendarflightDealBanner(props: Props) {
  const {
    destinationAirportCode,
    originAirportCode,
  } = props

  const [deals] = useFlightDeals('all', {
    originAirportCode,
    destinationAirportCode,
  })

  const activeDeal = useMemo(() => {
    return sortBy(deals, (deal) => deal.perAdultPrice, 'asc')[0]
  }, [deals])

  if (!activeDeal) {
    return null
  }

  return (
    <VerticalSpacer gap={8}>
      <BodyTextBlock variant="small" >
        <SolidFireIcon colour="critical" />

        <UrgencyLabel variant="critical1">
          Limited time flight offer
        </UrgencyLabel>{' '}

        <strong>{activeDeal.carrier.name} from <FormatCurrency value={activeDeal.perAdultPrice} format="roundedDollar" />/adult{' '}
          {fareTypeLabelMap[activeDeal.fareType]}
        </strong> in {fareCabinLabelMap[activeDeal.fareClass as FlightsClassTypes]}{' '}
        - Complete a search for live pricing and availability
      </BodyTextBlock>

      <UrgencyLabel variant="critical2">
        Offer ends in{' '}
        <OfferCalendarFlightDealBannerCountdown salesEndDate={activeDeal.salesEndDate} />
      </UrgencyLabel>
    </VerticalSpacer>
  )
}
